<template>
  <ion-page>
    <ion-header>
      <ion-toolbar color="dark" style="text-align: center">
              <ion-button  v-if="courseSelected.name!=Course.NULL.name" color="primary" @click="confirmBooking" style="float:right">Confirmar {{totalBooks}} libros {{ booksPrice2 }}€</ion-button>
              <ion-button  color="primary" @click="courseSelection" style="float:right">{{courseSelected.name}}</ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content >
        <ion-list v-if="courseSelected.name==Course.NULL.name">
          <ion-item button @click="selectCourse(course, this)" v-for="course in courses" :key="course.id">
            <ion-label>
              <h2>{{course.name}}</h2>
            </ion-label>
          </ion-item>
        </ion-list>
        <div v-if="courseSelected.name!=Course.NULL.name">
        <p class="ion-padding">Sólo se permite seleccionar libros de un curso</p>
        <div v-if="courseSelected.id=='1Pri'|| courseSelected.id=='2Pri'">
          <p style="margin:2rem; color:green">Si perteneces al banco de libros, recuerda descontar 160€ al realizar el pago.</p>
        </div>
      <ion-list>
        <ion-list-header>LIBROS</ion-list-header>
        <ion-card v-for="(book, idx) in booksVisible" :key="book.id" v-model="booksVisible">
        <ion-card-content>
             <ion-item>
             <ion-label><h2 style="font-weight:bolder">{{idx+1}} - {{book.name}}</h2></ion-label>
             <ion-checkbox :disabled="canSelect" v-model="book.selected" v-on:click="updateTotals()"></ion-checkbox>
            </ion-item>
            <h3>ISBN: <b>{{book.ISBN}}</b>  - Editorial: <b>{{book.editorial}}</b></h3>
            <h3><span style="vertical-align:middle;"> Precio: <b>{{book.price}}</b> €</span> - Idioma: <b> {{book.lang}}</b></h3>
            
            <span class="banco" v-if="book.banco">No incluido en banco de libros</span>
            <span v-if="book.comentario">{{book.comentario}}</span>

        </ion-card-content>
        </ion-card>
      </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { IonPage, IonHeader, IonToolbar,  IonContent,IonItem, 
  IonItemOption, 
  IonItemOptions, 
  IonItemSliding, 
  //IonIcon,
  IonButton,
  IonCheckbox,
  IonList, IonLabel, IonListHeader, 
  IonCardContent, IonCard,
  onIonViewWillEnter} from '@ionic/vue';
import { computed, onMounted, reactive, Ref, ref, toRef } from 'vue';
import  Book from '../model/Book';
import  Course from '../model/Course';
import  Contact from '../model/Contact';
import { star, removeOutline, addOutline } from 'ionicons/icons';
import axios from 'axios';
import bookservice from '../bookservice';
import router from '../router/index';


  const courseSelected = ref<Course>(Course.NULL);

  const booksReserved = ref<Book[]>();
  const booksReservedNumber = ref(0);
  const booksPrice = ref(0);
  enum Status  {
     Selecting = 1,
     Reservation,
     Confirm

  }
  const state = ref<Status>(Status.Selecting);

export default  {
  name: 'Tab1',
  components: {  IonHeader, IonToolbar, IonContent, IonPage, IonItem,IonButton , 
  //IonIcon,
  IonCheckbox,
  IonCard,IonCardContent,
  IonList,IonLabel , IonListHeader   },

  props : ['miprop'],

  data() {
    return {
      courses: Course.courses
    }
  },

  methods: {
    ionViewWillEnter() {
                console.log(this)
      console.log('ionWil', this ); // in the Composition API, this points to the object
      state.value=Status.Selecting
    },

    courseSelection(){
      courseSelected.value = Course.NULL
    },

    confirmBooking(){
        router.replace('/tabs/tab2');

    }
  },




  setup(context: any, props: any){
    const {books} = bookservice();
        
    const booksWithCount = books.value.filter(b=>b.selected);
    courseSelected.value=booksWithCount.length? booksWithCount[0].course: Course.NULL;
    const booksVisible = computed(()=>books.value.filter(b=>b.course==courseSelected.value))
    console.log("booksVisible", booksVisible)
    const listselect = ref<any>(null);


    const canSelect = ref(true);
    const found = books.value.find(b=> b.selected);
    canSelect.value=!(!found || found.course==courseSelected.value )

    const selectCourse = (course: Course, event: any)=>{
      courseSelected.value = course;
      const found = books.value.find(b=> b.selected);
      canSelect.value=!(!found || found.course==courseSelected.value )
      //booksVisible.value = books.value.filter(b=>b.course==course);
    };

    onMounted( ()=>{
        console.log("onmounted", props)
    });

  const updateTotals=function() {
    booksPrice.value = books.value.reduce( (total: number, book: Book) =>  {
      total=total + (book.selected?1:0)*book.price
      return total
  }, 0) || 0;
    console.log(booksPrice.value)
    booksReservedNumber.value = books.value.filter((b: Book)=>b.selected).length;
  }

  const totalBooks = computed(()=>books.value.filter(b=>b.selected).length);
  const booksPrice2 = computed(()=> books.value.reduce( (total: number, book: Book) =>  {
      total=total + (book.selected?1:0)*book.price
      return total
  }, 0) || 0);

  const deb = ()=>{
      console.log("dbe")
      console.log(props, books.value[2])

  }

    return {  booksVisible, booksReserved, booksPrice, booksPrice2, booksReservedNumber, courseSelected, star, removeOutline, addOutline, state, Status, updateTotals, books, listselect, selectCourse, deb, Course, totalBooks, canSelect  };

  }
}
</script>